import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadBlockData } from '../HocBlock/actions'

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadBlockData,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(null, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
